"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamsIntegrationModalContent = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _TeamsIntegrationModalFileListStep = require("../TeamsIntegrationModalFileListStep");
var _TeamsIntegrationModalMetadataStep = require("../TeamsIntegrationModalMetadataStep");
var _TeamsIntegrationReviewStep = require("../TeamsIntegrationReviewStep");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TeamsIntegrationModalContent = exports.TeamsIntegrationModalContent = function TeamsIntegrationModalContent(_ref) {
  var step = _ref.step,
    callbackClose = _ref.callbackClose,
    setSelectedChannel = _ref.setSelectedChannel,
    selectedChannel = _ref.selectedChannel,
    onLoadingChange = _ref.onLoadingChange;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, step === "fileList" && /*#__PURE__*/_react["default"].createElement(_TeamsIntegrationModalFileListStep.TeamsIntegrationModalFileListStep, {
    callbackClose: callbackClose,
    setSelectedChannel: setSelectedChannel,
    selectedChannel: selectedChannel,
    onLoadingChange: onLoadingChange
  }), step === "metadata" && /*#__PURE__*/_react["default"].createElement(_TeamsIntegrationModalMetadataStep.TeamsIntegrationModalMetadataStep, null), step === "review" && /*#__PURE__*/_react["default"].createElement(_TeamsIntegrationReviewStep.TeamsIntegrationReviewStep, null), step === "warning" && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    "data-testid": "warning-content"
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    fontSize: "14px"
  }, "Importing Teams item(s) will ", /*#__PURE__*/_react["default"].createElement("strong", null, "override"), " previously imported Teams item(s)."), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    fontSize: "14px"
  }, "Importing can be time consuming and costly so, we encourage teams to", " ", /*#__PURE__*/_react["default"].createElement("strong", null, "limit it to 4 times a month.")), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    fontSize: "14px"
  }, "You have imported the Teams item(s) ", /*#__PURE__*/_react["default"].createElement("strong", null, "2/4"), " times this month. Do you still want to import item(s)?")));
};